import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.Users';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Users',
    },
    nameColumnTitle: {
        id: `${scope}.nameColumnTitle`,
        defaultMessage: 'Name',
    },
    emailColumnTitle: {
        id: `${scope}.emailColumnTitle`,
        defaultMessage: 'Email',
    },
    propertyColumnTitle: {
        id: `${scope}.propertyColumnTitle`,
        defaultMessage: 'Properties',
    },
    pmsColumnTitle: {
        id: `${scope}.pmsColumnTitle`,
        defaultMessage: 'PMSs',
    },
    exportButton: {
        id: `${scope}.exportButton`,
        defaultMessage: 'Export user list',
    },
});
